import React from 'react'
import { StartStepImg, StartStepWrap } from '../index.styled'
import ClientMonitorCartLogo from '../common/ClientMonitorCartLogo'
import { useSelector } from 'react-redux'

const StartStep = React.memo(() => {
	const config = useSelector(state => state.clientMonitorConfig.config)

	if (!config) {
		return (
			<div
				data-testid="start-step-loader"
				className="flex h-full w-full flex-col items-center justify-center gap-8 bg-dark-surface"
			>
				<div className="h-20 w-20 animate-spin rounded-full border-4 border-dark-border border-t-brand-blue" />
				<span className="text-2xl font-medium tracking-wide text-dark-text-muted">Laden…</span>
			</div>
		)
	}

	const clientMonitorBackgroundImage = config.logoImg || '/img/clientMonitor/pizza.webp'

	return (
		<StartStepWrap>
			<StartStepImg src={clientMonitorBackgroundImage} alt="StartStep"></StartStepImg>
			<ClientMonitorCartLogo />
		</StartStepWrap>
	)
})

StartStep.displayName = 'StartStep'
export default StartStep
